import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ITablaDimensiones {
	key: string;
	filas: number;
	columnas: number;
}

const initialState: ITablaDimensiones[] = [];

const tablaDimensionesSlice = createSlice({
	name: 'tablaDimensiones',
	initialState,
	reducers: {
		setTablaFilas: (state, action: PayloadAction<{ key: string; filas: number }>) => {
			const index = state.findIndex((item) => item.key === action.payload.key);
			if (index !== -1) {
				// eslint-disable-next-line no-param-reassign
				state[index].filas = action.payload.filas;
			} else {
				state.push({ key: action.payload.key, filas: action.payload.filas, columnas: 0 });
			}
		},
		setTablaColumnas: (state, action: PayloadAction<{ key: string; columnas: number }>) => {
			const index = state.findIndex((item) => item.key === action.payload.key);
			if (index !== -1) {
				// eslint-disable-next-line no-param-reassign
				state[index].columnas = action.payload.columnas;
			} else {
				state.push({ key: action.payload.key, filas: 0, columnas: action.payload.columnas });
			}
		},
		addTabla: (state, action: PayloadAction<ITablaDimensiones>) => {
			state.push(action.payload);
		},
		resetTablaDimensiones: () => {
			return initialState;
		},
		resetSpecificTablaDimensiones: (state, action: PayloadAction<string>) => {
			return state.filter((item) => item.key !== action.payload);
		}
	}
});

export const { setTablaFilas, setTablaColumnas, addTabla, resetTablaDimensiones, resetSpecificTablaDimensiones } =
	tablaDimensionesSlice.actions;

export default tablaDimensionesSlice.reducer;
